// Privacy Policy Content Block JS
jQuery(document).ready(function () {
  const legalBasis = document.getElementById('legal_basis');
  const regulationRights = document.getElementById('regulation_rights');

  // Ensure both elements exist before proceeding
  if (legalBasis && regulationRights) {
    const count = legalBasis.getElementsByTagName('li').length;
    regulationRights.setAttribute('start', count + 1);
  }
});
